import React from "react";
import { Box, Typography } from "@mui/material";

export default function Footer() {
  return (
    <Box
      sx={{
        py: 4,
        textAlign: "center",
        background: "#0d0d0d",
        borderTop: "1px solid rgba(255,255,255,0.05)",
      }}
    >
      <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.6)" }}>
        © {new Date().getFullYear()} Early Warning System. All rights reserved.
      </Typography>
      <Typography
        variant="caption"
        sx={{ color: "rgba(255,255,255,0.4)", display: "block", mt: 0.5 }}
      >
        Powered by LUMS
      </Typography>
    </Box>
  );
}
